import {
  CV_SELECTED_CASELIST_FETCHITEMS_LOAD,
  CV_SELECTED_CASELIST_FETCHITEMS_SUCCEED,
  CV_SELECTED_CASELIST_FETCHITEMS_FAIL,
  CV_SELECTED_CASELIST_CHANGETABLE_CHANGE,
  CV_SELECTED_CASELIST_SEARCHTABLE_EDIT,
  CV_SELECTED_CASELIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case CV_SELECTED_CASELIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case CV_SELECTED_CASELIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pa: action.pa,
        pagination: { ...state.pagination, total: action.total },
      }
    case CV_SELECTED_CASELIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case CV_SELECTED_CASELIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case CV_SELECTED_CASELIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case CV_SELECTED_CASELIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}
